const sessionStatuses = {
	BOOKED: "booked",
	CANCELLED: "cancelled",
	DONE: "done",
};

export default sessionStatuses;
